import React from "react";
import appleStore from "../landing-page/images/app-store-ic.svg";
import googlePlay from "../landing-page/images/google-pay-ic.svg";
import mobileImage from "../landing-page/images/mobile-img.png";
import "../landing-page/css/style.css";
import "../landing-page/css/media.css";
// import "../landing-page/css/animate.min.css";
const MainBanner = () => {
  return (
    <div
      className="main-banner wow fadeInUp"
      style={{ visibility: "visible", animationName: "fadeInUp" }}
    >
      <div className="banner-txt">
        <div className="fixed-wrapper">
          <div className="banner-txt-outer ">
            <h1 className="!text-[22px] sm:!text-[34px] !font-bold 2xl:!text-[56px] xl:!text-[56px] lg:!text-[46px] md:!text-[42px]">
              Use TXTBET to create <br /> unique bets to compete with <br />{" "}
              <span>friends and family</span>
            </h1>
            <ul className="btn-list">
              <li>
                <a href="#">
                  <img src={appleStore} alt="App Store" className="" />
                </a>
              </li>
              <li>
                <a href="#">
                  <img src={googlePlay} alt="Google Pay" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mobile-anumation">
        <div className="fixed-wrapper">
          <div className="mobile-animation-outer">
            <svg height="715px" width="715px">
              <circle
                id="circle-5"
                style={{ opacity: 1 }}
                r="350"
                cx="350"
                cy="350"
                fill="#F6F6F6"
                strokeWidth="1"
                stroke="rgba(6, 26, 58, 0.2)"
              />
              <circle
                id="circle-4"
                style={{ opacity: 1 }}
                r="280"
                cx="350"
                cy="350"
                fill="#F6F6F6"
                strokeWidth="1"
                stroke="rgba(6, 26, 58, 0.2)"
              />
              <circle
                id="circle-3"
                style={{ opacity: 0 }}
                r="210"
                cx="350"
                cy="350"
                fill="#F6F6F6"
                strokeWidth="1"
                stroke="rgba(6, 26, 58, 0.2)"
              />
              <circle
                id="circle-2"
                style={{ opacity: 0 }}
                r="140"
                cx="350"
                cy="350"
                fill="#F6F6F6"
                stroke="rgba(6, 26, 58, 0.2)"
              />
              <circle
                id="circle-1"
                style={{ opacity: 0 }}
                r="70"
                cx="350"
                cy="350"
                fill="#F6F6F6"
                strokeWidth="1"
                stroke="rgba(6, 26, 58, 0.2)"
              />
              <circle
                stroke="#ffffff"
                id="circle-0"
                style={{ opacity: 1 }}
                r="20"
                cx="300"
                cy="700"
                fill="#fff"
              />
              <animate
                xlinkHref="#circle-1"
                attributeType="CSS"
                attributeName="opacity"
                from="0"
                to="1"
                dur="3s"
                repeatCount="indefinite"
                values="0; 1; 1; 1; 1; 1; 0"
              />
              <animate
                xlinkHref="#circle-2"
                attributeType="CSS"
                attributeName="opacity"
                from="0"
                to="1"
                dur="3s"
                repeatCount="indefinite"
                values="0; 0; 1; 1; 1; 1; 0"
              />
              <animate
                xlinkHref="#circle-3"
                attributeType="CSS"
                attributeName="opacity"
                from="0"
                to="1"
                dur="3s"
                repeatCount="indefinite"
                values="0; 0; 0; 1; 1; 1; 0"
              />
              <animate
                xlinkHref="#circle-4"
                attributeType="CSS"
                attributeName="opacity"
                from="0"
                to="1"
                dur="3s"
                repeatCount="indefinite"
                values="0; 0; 0; 0; 1; 1; 0"
              />
              <animate
                xlinkHref="#circle-5"
                attributeType="CSS"
                attributeName="opacity"
                from="0"
                to="1"
                dur="3s"
                repeatCount="indefinite"
                values="0; 0; 0; 0; 0; 1; 0"
              />
            </svg>
            <em>
              <img src={mobileImage} alt="Mobile Animation" />
            </em>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBanner;
